// extracted by mini-css-extract-plugin
module.exports = {"container":"BackgroundImage_container__19ytD","mainImage":"BackgroundImage_mainImage__3xpCj","logoImage":"BackgroundImage_logoImage__4iYam"};